module.exports = __webpack_public_path__ + "static/img/5.56aef64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/5.png
// module id = aGsK
// module chunks = 0